import { useTagsQuery } from 'src/app/queries/configuration/tags/get-tags';

export function useProductListColumns() {
  const { data: tags } = useTagsQuery();

  const formatTagNameFromIds = (tagList) => {
    if (!tagList || tagList.length === 0) {
      return '';
    }
    return tagList.map((tag: number) => tags?.find(({ TagId }) => TagId === tag)?.TagName);
  };

  return [
    {
      field: 'ProductDesc',
      headerName: 'Product',
      defaultWidth: 200,
    },
    {
      field: 'ProductNo',
      headerName: 'SKU',
    },
    {
      field: 'ProductId',
      headerName: 'ID',
      hide: true,
    },
    {
      field: 'Available',
      headerName: 'Qty available',
    },
    {
      field: 'Brand',
      headerName: 'Brand',
    },
    {
      field: 'Weight',
      headerName: 'Weight',
    },
    {
      field: 'Category',
      headerName: 'Category',
    },
    {
      field: 'MasterCategory',
      headerName: 'Master category',
    },

    {
      field: 'Vendor',
      headerName: 'Vendor',
      hide: true,
    },
    {
      field: 'Strain',
      headerName: 'Strain',
      hide: true,
    },
    {
      field: 'InventoryTagIds',
      headerName: 'Product tags',
      valueFormatter: ({ value }) => formatTagNameFromIds(value),
      hide: true,
    },
    {
      field: 'TagIds',
      headerName: 'Catalog tags',
      valueFormatter: ({ value }) => formatTagNameFromIds(value),
      hide: true,
    },
  ];
}
